import type { CartItemEntity } from '@/domain/entities/cart.entity';

export type GroupedCartItem =
  | { kind: 'item'; item: CartItemEntity }
  | { kind: 'pack'; packId: string; items: CartItemEntity[] };

/**
 * Groups contiguous cart lines that share the same pack_id.
 * Non-pack lines are emitted as standalone items.
 */
export function groupCartItems(items: CartItemEntity[]): GroupedCartItem[] {
  const result: GroupedCartItem[] = [];
  const packBuckets = new Map<string, CartItemEntity[]>();

  for (const item of items) {
    const packId = item.pack_id;
    if (packId) {
      if (!packBuckets.has(packId)) {
        packBuckets.set(packId, []);
        result.push({ kind: 'pack', packId, items: packBuckets.get(packId) as CartItemEntity[] });
      }
      (packBuckets.get(packId) as CartItemEntity[]).push(item);
    } else {
      result.push({ kind: 'item', item });
    }
  }

  return result;
}
